export const dateRange = {
  today: 'Today',
  thisWeek: 'This Week',
  thisMonth: 'This Month',
  thisYear: 'This Year',
  lastYear: 'Last Year',
  customRange: 'Custom Range',
};
export const dateRangeOptions = Object.values(dateRange).map(range => ({
  label: range,
  value: range,
}));

export const allDateRange = {
  allTime: 'All Time',
  today: 'Today',
  thisWeek: 'This Week',
  thisMonth: 'This Month',
  thisYear: 'This Year',
  lastYear: 'Last Year',
  customRange: 'Custom Range',
};

export const dateRangeOptionsWithAllTime = Object.values(allDateRange).map(
  range => ({
    label: range,
    value: range,
  }),
);
